import React, { useState, useEffect } from 'react'
import { Loader } from '../../../../utils/loaderButton'
import { toast } from 'react-toastify'
import { store } from '../../../../Redux/store'
import axios from 'axios'
import { HOSTNAME } from '../../../../lib/Apiendpoint'
import { BsLink, BsShare } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'

const ShareUrl = ({ data }) => {
  const [qrCode, setQrCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [downloadloading, setDownloadLoading] = useState(false)

  const { t } = useTranslation()


  const fetchQrCode = async () => {
    if (!data?.id) return
    try {
      setLoading(true)
      // Get token from your store
      const token = store.getState().userAuth?.loginInfo?.token

      // Make the API request
      const response = await axios({
        method: "get",
        url: `${HOSTNAME}/servicer/properties/qr-code/${data.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "image/png,image/*",
          token: token,
        },
        responseType: "arraybuffer",
      })

      // Convert ArrayBuffer to Base64
      const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""))

      // Create data URL
      const dataUrl = `data:image/png;base64,${base64}`
      setQrCode(dataUrl)
    } catch (err) {
      console.error("Error fetching QR code:", err)
      toast.error(err.message || "Error fetching QR code")
    } finally {
      setLoading(false)
    }
  }


  const copyToClipboard = () => {
    navigator.clipboard.writeText(data?.share_url)
    toast.success(t('url_copy'))
  }


  const handleShare = async (title, text, url) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url
        })
      } catch (error) {
        console.error("Error sharing:", error)
      }
    } else {
      toast.error(t('browser_support'))
    }
  }


  const downloadImage = () => {
    setDownloadLoading(true)
    setTimeout(() => {
      // Create a temporary link element
      const link = document.createElement("a")
      link.href = qrCode // Set the URL of the image
      link.download = "qrcode.png" // Set the desired file name
      link.target = "_blank" // Open in a new tab
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setDownloadLoading(false)
    }, 2000);

  }


  useEffect(() => {
    fetchQrCode()
  }, [])

  return (
    <div className="w-[500px]">
      {
        loading ? (
          <Loader type="loadData" />
        ) : (
          <div className='w-full  '>
            <div className=''>
              <h2 className='text-2xl font-bold mb-4'>{t('share_url')}</h2>
              <div className="flex items-center gap-5 ">
                <div className="w-full">
                  <input
                    type='text'
                    disabled
                    value={data?.share_url}
                    className='border border-gray-300 rounded-lg p-3 w-full '
                    placeholder='https://example.com/share-url'
                  />
                </div>
                <div className='bg-white border shadow-md rounded-md p-3 cursor-pointer' onClick={() => handleShare("Share Url", "Share Url", data?.share_url)}>
                  <BsShare size={20} />
                </div>
                <div className='bg-white border shadow-md rounded-md p-3 cursor-pointer' onClick={() => copyToClipboard()}>
                  <BsLink size={20} />
                </div>
              </div>

              {/* <button onClick={() => handleShare("Share Url","Share Url",data?.share_url)} className='bg-[#FF8C00] text-white w-full rounded-lg py-2 px-4 '>
                Copy Link
              </button> */}
            </div>
            <div className='pt-10'>
              <h2 className='text-2xl font-bold mb-4'>{t('qr_code')}</h2>
              <div className='flex justify-center items-center flex-col'>
                <img src={qrCode} alt='QR Code' className='w-1/2 h-1/2' />
                <div className='max-w-[800px] mx-auto'>
                  <button onClick={() => downloadImage()} className='bg-[#FF8C00] w-full text-white rounded-lg py-2 px-4 mt-5 '>
                    {downloadloading ? <Loader type="single" /> : t('download_qr_code')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

    </div>
  )
}

export default ShareUrl